import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { IntensitySimulationMap } from "../../modals/IntensitySimulationMap";
import { IntensitySimulationMap } from "../../IntensitySimulationMap";

// const EARTHQUAKE_LATITUDE_INPUT_ELEMENT_ID = "input.text.earthquake.latitude";
// const EARTHQUAKE_LONGITUDE_INPUT_ELEMENT_ID = "input.text.earthquake.longitude";
// const EARTHQUAKE_MAGNITUDE_INPUT_ELEMENT_ID = "input.text.earthquake.magnitude";
// const USER_LATITUDE_INPUT_ELEMENT_ID = "input.text.user.latitude";
// const USER_LONGITUDE_INPUT_ELEMENT_ID = "input.text.user.longitude";

const DEFAULT_EARTHQUAKE_DEPTH = 12.0; // 12 km

const Gyeongju2016Earthquake = {
  magnitude: 5.8,
  latitude: 35.76,
  longitude: 129.19,
  depth: 15.0,
};

const Pohang2017Earthquake = {
  magnitude: 5.4,
  latitude: 36.11,
  longitude: 129.37,
  depth: 7.0,
};

const defaultLocation = {
  latitude: 36.3799,
  longitude: 127.3605,
};

export const IntensitySimulation = () => {
  const [earthquake, setEarthquake] = useState(Gyeongju2016Earthquake);
  const [userLocation, setUserLocation] = useState(defaultLocation);
  const [isCurrentLocation, setIsCurrentLocation] = useState(false);
  const [simulationParameters, setSimulationParameters] = useState(null);
  // const [showSimulationMap, setShowSimulationMap] = useState(false);
  // const [earthquakeMagnitudeType, setEarthquakeMagnitudeType] = useState("custom");
  // const { t } = useTranslation();
  // const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => getUserCurrentLocation(true), []);

  const handleEarthquakeChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, value } = event.target;
      const parsedValue = parseFloat(value.trim());
      if (!isNaN(parsedValue)) {
        setEarthquake({
          ...earthquake,
          [name]: parsedValue,
        });
      }
    }
  };

  const handleUserLocationChanged = (event) => {
    if (event.target && event.target.name) {
      const { name, value } = event.target;
      const parsedValue = parseFloat(value.trim());
      if (!isNaN(parsedValue)) {
        const currentValue = userLocation[name];
        if (currentValue !== parsedValue) {
          setUserLocation({
            ...userLocation,
            [name]: parsedValue,
          });
          setIsCurrentLocation(false);
        }
      }
    }
  };

  const getUserCurrentLocation = (silent = false) => {
    const onSuccess = (position) => {
      // console.log(position);
      const { latitude, longitude } = position.coords;
      setUserLocation({ latitude, longitude });
      setIsCurrentLocation(true);
    };
    const onError = (error) => {
      console.log(error);
      if (!silent) {
        alert(t("page.intensity-simulation.failedToLoadUsersLocation"));
      }
    };
    console.log("getUserCurrentLocation", silent);
    navigator.geolocation.getCurrentPosition(onSuccess, onError);
  };

  const simulate = () => {
    console.log(earthquake, userLocation);
    setSimulationParameters({ earthquake, user: userLocation });
    // setShowSimulationMap(true);
  };

  return (
    <div className="container">
      <div className="sub-container">
        <div style={{ fontSize: "15px", marginBottom: "5px" }}>
          &nbsp;&nbsp;<i className="ion ion-md-help-circle-outline"></i>
          {t("page.intensity-simulation.desc")}
        </div>
        <div className="overflow-auto">
          <table className="datatable mb20">
            <colgroup>
              <col style={{ width: "20%" }} />
              <col style={{ width: "80%" }} />
            </colgroup>
            <tbody>
              <tr>
                <th className="first">{t("w.earthquake")}</th>
                <td className="first clearfix">
                  <div className="inline-block" style={{ marginRight: 10 }}>
                    {t("w.latitude")}
                    <input
                      className="multiinput inputmid"
                      type="number"
                      name="latitude"
                      min={-90}
                      max={90}
                      step={0.0001}
                      // defaultValue="35.76"
                      aria-label="지진 위도"
                      value={earthquake.latitude}
                      onChange={handleEarthquakeChanged}
                    />
                  </div>
                  <div className="inline-block" style={{ marginRight: 10 }}>
                    {t("w.longitude")}
                    <input
                      className="multiinput inputmid"
                      type="number"
                      name="longitude"
                      min={-180}
                      max={180}
                      step={0.0001}
                      // defaultValue="129.19"
                      aria-label="지진 경도"
                      value={earthquake.longitude}
                      onChange={handleEarthquakeChanged}
                    />
                  </div>
                  <div className="inline-block">
                    {t("w.magnitude")}
                    <input
                      className="multiinput"
                      type="number"
                      name="magnitude"
                      min={0}
                      max={9.9}
                      step={0.1}
                      aria-label="지진 규모"
                      value={earthquake.magnitude}
                      onChange={handleEarthquakeChanged}
                    />
                  </div>
                  <div className="inline-block">
                    {t("w.depth")} (km)
                    <input
                      className="multiinput"
                      type="number"
                      name="depth"
                      min={0}
                      max={30.0}
                      step={1}
                      aria-label="진원 깊이"
                      value={earthquake.depth}
                      onChange={handleEarthquakeChanged}
                    />
                  </div>
                  <div>
                    <button
                      type="button"
                      className="waves-effect waves-light button-sm btn-block"
                      onClick={() => setEarthquake(Gyeongju2016Earthquake)}
                    >
                      {t("page.intensity-simulation.GyeongjuEarthquake")} (2016)
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      className="waves-effect waves-light button-sm btn-block"
                      onClick={() => setEarthquake(Pohang2017Earthquake)}
                    >
                      {t("page.intensity-simulation.PohangEarthquake")} (2017)
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{t("page.intensity-simulation.myLocation")}</th>
                <td className="clearfix">
                  <div className="inline-block" style={{ marginRight: 10 }}>
                    {t("w.latitude")}
                    <input
                      className="multiinput inputmid"
                      type="number"
                      name="latitude"
                      min={-90}
                      max={90}
                      step={0.0001}
                      // defaultValue="36.3799"
                      aria-label="내 위치 위도"
                      value={userLocation.latitude}
                      onChange={handleUserLocationChanged}
                    />
                  </div>
                  <div className="inline-block" style={{ marginRight: 10 }}>
                    {t("w.longitude")}
                    <input
                      className="multiinput inputmid"
                      type="number"
                      name="longitude"
                      min={-180}
                      max={180}
                      step={0.0001}
                      // defaultValue="127.3605"
                      aria-label="내 위치 경도"
                      value={userLocation.longitude}
                      onChange={handleUserLocationChanged}
                    />
                  </div>
                  {isCurrentLocation ? (
                    `(${t("page.intensity-simulation.locationHasBeenLoaded")})`
                  ) : (
                    <button
                      type="button"
                      className="waves-effect waves-light button-sm btn-block"
                      onClick={() => getUserCurrentLocation()}
                    >
                      {t("page.intensity-simulation.loadMyLocation")}
                    </button>
                  )}
                  {/* <button
                    type="button"
                    className="waves-effect waves-light button-sm btn-block"
                    onClick={() => getUserCurrentLocation()}
                  >
                    내 위치 가져오기
                  </button> */}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="center-align row">
            <button
              type="button"
              className="waves-effect waves-light button-lg btn-block"
              onClick={simulate}
            >
              {t("page.intensity-simulation.simulate")}
            </button>
          </div>
        </div>
      </div>
      <IntensitySimulationMap simulationParameters={simulationParameters} />
      {/* {showSimulationMap && (
        <IntensitySimulationMap
          earthquake={earthquake}
          userLocation={userLocation}
          onClose={() => setShowSimulationMap(false)}
        />
      )} */}
    </div>
  );
};
